import { useState } from "react";
import { Box, Chip, Typography } from "@mui/joy";
import { Clock, PackageCheck } from "lucide-react";
import moment from "moment";

import { TaskActionComponent } from "../../../components/Tasks/components";
import { EstimateContract } from ".";

interface IEstimateContractComponent {
    activeTask: any;
    onComplete: () => void;
    actionProgress: any;
    measurements: any;
}

export default function TaskComponent(props: IEstimateContractComponent) {
    const { activeTask, onComplete, actionProgress, measurements } = props;
    const { CreatedAt, Status } = activeTask || { CreatedAt: new Date(), Status: "PENDING" };

    const [isNextStageEligible, setIsNextStageEligible] = useState({ isSupplierSelected: true }); // Defaulting to true for now
    const isNextStageReady = Object.values(isNextStageEligible).every((value) => value === true);

    return (
        <Box>
            <Box mt={2} ml={1} mr={1}>
                <Typography startDecorator={<PackageCheck size={16} />} level="body-sm" gutterBottom>
                    Task
                </Typography>
                <Typography
                    level="h4"
                    sx={{ fontWeight: 500, display: "flex", alignItems: "center", gap: 0.5 }}
                    component={"div"}
                >
                    Estimate/Contract
                </Typography>

                <Box mt={2} display={"flex"} gap={1}>
                    <Chip
                        color={Status === "COMPLETED" ? "success" : "warning"}
                        sx={{ fontSize: 12, border: "1px solid", borderColor: "divider" }}
                    >
                        {Status}
                    </Chip>
                    <Chip color="neutral" variant="outlined" sx={{ fontSize: 12 }} startDecorator={<Clock size={14} />}>
                        Created On: {moment(CreatedAt).format("MM/DD/YYYY")}
                    </Chip>
                </Box>

                <EstimateContract
                    measurements={measurements}
                    setIsNextStageEligible={setIsNextStageEligible}
                />

                <TaskActionComponent
                    taskName={"Estimate/Contract"}
                    onComplete={onComplete}
                    actionProgress={actionProgress}
                    isNextEligible={isNextStageReady}
                />
            </Box>
        </Box>
    );
}
